<template>
	<div class="flex flex-center aisle-container">
		<div v-if="city && (aisleInfo || department)" class="flex-row">
			<span style="white-space: nowrap;">
				Find in
			</span>
			<div v-if="aisleInfo" class="aisle-info">
				Aisle {{ aisleInfo }}
			</div>
			<div v-else-if="department" class="aisle-info">
				{{ department }}
			</div>
			<span style="white-space: nowrap;">
				at
				<link-button
					class="store-location-modal-link"
					@click.stop.prevent="showStoreDetailsModal = true"
					aria-label="Open store location modal"
				>
					{{ city }}
				</link-button>
			</span>
		</div>
	</div>
</template>

<script>
import LinkButton from 'Src/js/components/LinkButton.vue';
export default {
	name: 'InStoreLocation',
	components: {
		LinkButton,
	},
	props: {
		aisleInfo: String,
		city: String,
		department: String,
	},
	computed: {
		showStoreDetailsModal: {
			get() {
				return this.$store.state.showStoreDetailsModal;
			},
			set(val) {
				this.$store.commit('showStoreDetailsModal', val);
			}
		},
	}
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';
.aisle-container {
	margin: 10px;
	color: #666;
	font-size: 12px;
	font-weight: bold;
}
.aisle-info {
	border: 1px solid #95989A;
	border-radius: 6px;
	margin: 0 5px;
	padding: 5px 10px;
	font-size: 14px;
	font-weight: 500;
	color: #666666;
	text-align: center;
}
.store-location-modal-link {
	font-size: 14px;
	margin-left: 2px;
}
</style>